import { Container, Typography } from '@mui/material';

export function NotFound() {
  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', mt: 8 }}>
      <Typography variant="h2" gutterBottom>
        404 - ページが見つかりません
      </Typography>
      <Typography variant="h5" gutterBottom>
        申し訳ありません、お探しのページは存在しません。
      </Typography>
    </Container>
  );
}
